/**
* 基础菜单 角色管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.roleName" placeholder="角色名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="">-->
<!--        <el-input size="small" v-model="formInline.seller_code" placeholder="店铺商家编号" clearable></el-input>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addrole" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editrole" class="edit-button">修改</el-button>
        <el-button size="small" type="warning" @click="setPower">设置权限</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 60%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="role_name" label="角色名称" min-width="180" :show-overflow-tooltip='true'>
        </el-table-column>
<!--        <el-table-column prop="role" label="是否管理员角色" width="180" :show-overflow-tooltip='true'>-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.role==1">是</div>-->
<!--            <div v-else>否</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="status" label="有效状态" width="90">
          <template slot-scope="scope">
            <div v-if="scope.row.id=='1'">
              <el-switch @change="changeStatus(scope.row.id,scope.row.status)"
                         v-model="scope.row.status"
                         :active-value="1"
                         :inactive-value="0"
                         disabled
                         active-color="#409EFF">
              </el-switch>
            </div>
            <div v-else>
              <el-switch @change="changeStatus(scope.row.id,scope.row.status)"
                         v-model="scope.row.status"
                         :active-value="1"
                         :inactive-value="0"
                         active-color="#409EFF">
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="creater" label="创建人" width="180">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150">
          <template slot-scope="scope">
            <div>{{scope.row.create_time|timestampToTime}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="roleDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="addForm" :rules="addRules" ref="addForm" class="addForm">
        <el-form-item label="角色名称" prop="roleName" class="relative r50">
          <el-input size="small" v-model="addForm.roleName" auto-complete="off" clearable maxlength="30"
                    placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="是否管理员角色" prop="role" class="relative r50">-->
<!--          <el-select v-model="addForm.role" placeholder="请选择是否管理员角色" clearable>-->
<!--            <el-option v-for="item in rolesList" :key="item.value" :label="item.name"-->
<!--                       :value="item.value"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveButton('addForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="设置权限"
               :visible.sync="powerDialogVisible"
               width="30%"
               center>
      <el-form label-width="155px" :model="powerForm" :rules="addRules" ref="powerForm" class="addForm">
        <el-form-item label="角色名称" prop="roleName" class="relative r50">
          <el-input size="small" v-model="powerForm.roleName" auto-complete="off" clearable maxlength="100" disabled
                    placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限内容" prop="func_name">
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            ref="tree"
            default-expand-all
            :default-checked-keys="checkedList"
            :props="defaultProps">
          </el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="savePowerButton('powerForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="powerDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleAdd,
  roleEdit,
  roleAssignPermissions,
  roleGetPermissionListByUser,
  roleRolePermissionTree
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'

  export default {
    data: () => {
      return {
        defaultProps:{
          label: "func_name",
          children: "children"
        },
        loading: false, //是显示加载
        roleDialogVisible: false,  // 弹窗
        powerDialogVisible: false,
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        productOptions: [],
        productOptionsHome: [],
        formInline: {
          pageNo: 1,
          pageSize: 10,
          roleName: "",
          seller_code: "",
          status: ''
        },
        addRules: {
          roleName: [{required: true, message: '请输入角色名称', trigger: 'blur'}],
          status: [{required: true, message: '请选择有效状态', trigger: 'blur'}],
        },
        addForm: {
          id: "",
          roleName: "",
          status: "",
          role: "",
        },
        powerForm: {
          roleName: '',
          func_name: ''
        },
        defaultParams: {
          label: 'text',
          value: 'id',
          childrens: 'childrens'
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        isCanSubmit: true,
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        rolesList: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        props: {multiple: true, label: 'name', value: 'id'},
        powerData: [],
        selectOptions: [],
        menusList: [],
        roleId: '',
        treeData: [],
        checkedList : []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      // 获取公司列表
      getdata() {
        this.loading = true
        roleList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.pageNo
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageNo = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增角色
      addrole() {
        this.roleDialogVisible = true;
        this.dialogTitle = '新增角色';
        this.addForm = {
          id: "",
          roleName: "",
          status: "",
          role: "",
        };
      },
      // 修改角色
      editrole() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].id == 1) {
          this.$message.error('超级管理员不允许修改!');
          return
        }
        this.dialogTitle = '修改角色';
        this.roleDialogVisible = true;
        this.addForm.roleName = this.selectTableData[0].role_name;
        this.addForm.status = this.selectTableData[0].status;
        this.addForm.role = this.selectTableData[0].role;
        this.productId = this.selectTableData[0].id;
      },
      // 新增角色-保存
      saveButton(formName) {
        if (this.dialogTitle == '修改角色') {
          this.addForm.id = this.productId;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增角色') {
              roleAdd(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加角色!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              roleEdit(this.addForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改角色!'
                    });
                    this.handleClose()
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      setPower() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].id == 1) {
          this.$message.error('超级管理员不允许设置权限!');
          return
        }
        this.powerForm.roleName = this.selectTableData[0].role_name;
        this.roleId = this.selectTableData[0].id;
        this.powerDialogVisible = true;
        this.selectOptions = [];
        this.menusList =[];
        this.checkedList = [];
        this.loading = true
        roleRolePermissionTree(this.selectTableData[0].id)
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.treeData = res.content;
              res.content.forEach((item) => {
                if(item.permission == 1 && item.pid != 0) {
                  this.checkedList.push(item.id);
                }
                if(item.children) {
                  item.children.forEach((child) => {
                    if(child.permission == 1) {
                      this.checkedList.push(child.id);
                    }
                  });
                }
              })
              this.loading = false
              this.getdata(this.formInline)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      savePowerButton() {
        var list = this.$refs.tree.getCheckedNodes();
        for(var i = 0; i < list.length; i++) {
          this.selectOptions.push(list[i].id);
          if(list[i].pid !== 0) {
            this.selectOptions.push(list[i].pid);
          }
        }
        this.selectOptions = [...new Set(this.selectOptions)];
        this.selectOptions = this.selectOptions.filter(item => item != 0);
        console.log(this.selectOptions)
        let data = {
          id: this.roleId,
          permissions: this.selectOptions
        }
        this.loading = true;
        roleAssignPermissions(data)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.powerDialogVisible = false;
              this.$message({
                type: 'success',
                message: '已成功为该角色设置权限'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      // 搜索事件
      search() {
        this.formInline.pageNo = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["addForm"].resetFields();
        this.roleDialogVisible = false;
      },
      changeStatus(id, status) {
        if (!status) {
          let body = {
            id: id,
            status: 0
          }
          roleEdit(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          let body = {
            id: id,
            status: 1
          }
          roleEdit(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.role_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .addForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addForm .el-input {
    width: 320px;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .addForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .addForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .addForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/power/role.vue